import Api from '../api';

const { axios: api } = Api;
const PREFIX = 'opinion';

export const createOpinion = async (payload) => {
	const { person, ...rest } = payload;

	const data = await api.post(`/${PREFIX}`, {
		...rest,
		person: person?.toString?.() ?? person,
	});
	return { data: data.data };
};
